import {useAppTranslation} from 'services/i18n';
import {useState} from 'react';
import {ContentLayoutWithControls} from './ContentLayoutWithControls';

interface Props {
    htmlContent?: string;
    onNavigateToNextStep: () => void;
    onNavigateToPreviousStep: () => void;
    isLastStep: boolean;
    contentLoading?: boolean;
    showCourseIncompleteModal: boolean;
}

export const HtmlViewer = ({
    htmlContent,
    onNavigateToNextStep,
    onNavigateToPreviousStep,
    isLastStep,
    contentLoading,
    showCourseIncompleteModal,
}: Props) => {
    const [zoomScale, setZoomScale] = useState(1);

    const t = useAppTranslation();

    const handleZoomIn = () => {
        zoomScale < 2 && setZoomScale(zoomScale + 0.1);
    };

    const handleZoomOut = () => {
        zoomScale > .5 && setZoomScale(zoomScale - 0.1);
    };

    return (
        <ContentLayoutWithControls
            contentLoading={contentLoading}
            leftKeyText={t('contentViewer.keyboardControls.back')}
            onLeftKeyPress={onNavigateToPreviousStep}
            leftKeyDisabled={false}
            rightKeyText={!isLastStep ? t('contentViewer.keyboardControls.endStep') : undefined}
            onRightKeyPress={!isLastStep ? onNavigateToNextStep : undefined}
            enterKeyText={isLastStep ? t('contentViewer.keyboardControls.certificate') : undefined}
            onEnterKeyPress={isLastStep && !showCourseIncompleteModal ? onNavigateToNextStep : undefined}
            handleZoomIn={handleZoomIn}
            handleZoomOut={handleZoomOut}
        >
            <div className="tw-h-full tw-w-full tw-overflow-auto" style={{background: '#F5F5F5'}}>
                <div className="tw-my-20 tw-mx-auto" style={{maxWidth: '720px'}}>
                    <div
                        dangerouslySetInnerHTML={{__html: htmlContent || ''}}
                        className="quill-render"
                        style={{zoom: `${zoomScale}`}}
                    ></div>
                </div>
            </div>
        </ContentLayoutWithControls>
    );
};
